import React, { useMemo } from 'react';
import { matchPath, Navigate, useLocation } from 'react-router-dom';

import { configs } from '@hero/configs';
import { ROUTE_PATHS } from '@hero/routes';
import { storage } from '@hero/utils';

export function UnderMaintenance({ children }) {
  const location = useLocation();

  const mustBeNavigate = useMemo(
    () =>
      configs.underMaintenance.enabled &&
      !matchPath(location.pathname, ROUTE_PATHS.UNDER_MAINTENANCE) &&
      storage.getUnderMaintenance() !== 'disabled',
    [location.pathname]
  );

  if (mustBeNavigate) {
    return <Navigate to={ROUTE_PATHS.UNDER_MAINTENANCE} />;
  }

  return children;
}
